<template>
  <div class="flex flex-row justify-center mb-12">
    <div class="flex items-center" v-for="idx in [1,2,3,4,5]" :key="idx">
      <div
        class="flex items-center justify-center font-bold shadow-lg mx-2 p-4 rounded-full h-8 w-8"
        :class="(idx == active ? 'bg-gray-600 text-white' : 'text-gray-500')"
      >{{idx}}</div>
      <div class="border-t-2 w-4 md:w-8 border-gray-400" :class="(idx == 5 ? 'hidden' : '')">&nbsp;</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: Number,
  },
}
</script>